export default "__VITE_ASSET__BJWxiTgC__"